import { Injectable } from "@angular/core";
import { ConnectionServices } from "../authentication/connection/connection.service";
import { IdentityService } from "../authentication/identity.service";
import { GetCountContractorsCommand, IGetCountContractorsParameters } from "./command/getCountContractors.command";
import { GetContractorEmployeesByPassengerIdCommand, IGetContractorEmployeesByPassengerCommandParameters } from "./command/getContractorEmployeesByPassengerId.command";
import {
  IContractorAreaRequestDTO,
  IContractorAreaResponseDTO,
  IContractorAreaAssignRequestDTO,
  ContractorResponseDto,
  IContractorEmployeeResponseDto,
  IContractorEmployeeRequestDto
} from "../authentication/connection/interfaces/apiInterfaces";
import {
  GetAreasByContractorIdCommand,
  IGetAreasByContractorIdCommandParameters
} from "./command/getAreasByContractorId.command";
import { DeleteContractorEmployeeCommand, IUpdateContractorEmployeeResponse } from "./command/deleteContractorEmployee.command";
import { GetContractorByIdCommand } from "./command/getContractorById.command";
import { GetContractorByEntityIdCommand } from "./command/getContractorByEntityId.command";
import { GetContractorByMagiisNumberCommand, IGetContractorByMagiisNumberCommandParameters } from "./command/getContractorByMagiisNumber.command";
import { GetContractorByTributeNumberCommand, IGetContractorByTributeNumberCommandParameters, IGetContractorByTributeNumberResponse } from "./command/getContractorByTributeNumber.command";
import { NotificationsService } from "../../services/notifications/notifications.service"
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { DeleteContractorAreaCommand, IUpdateContractorAreaResponse } from "./command/deleteContractorArea.command";
import { AssignContractorAreaCommand, IAssignContractorAreaResponse } from "./command/assignContractorArea.command";
import { CreateContractorAreaCommand, ICreateContractorAreaResponse } from "./command/createContractorArea.command";
import { UpdateContractorAreaCommand } from "./command/updateContractorArea.command";
import { CreateContractorEmployeeCommand, ICreateContractorEmployeeResponse } from "./command/createContractorEmployee.command";
import { GetContractorEmployeeCommand } from "./command/getContractorEmployee.command";
import { UpdateContractorEmployeeCommand } from "./command/updateContractorEmployee.command";
import { PutEmailTemplateCommand } from "./command/putEmailTemplate.command";
import { GetEmailTemplatesCommand } from "./command/getEmailTemplates.command";
import { ContractorEmployeesResendInviteCommand, IContractorEmployeesResendInviteCommandParameters, IContractorEmployeesResendInviteResponse } from "./command/contractorEmployeesResendInviteCommand";
import { AddAuthServiceTypeCommand, AddSubstractLimitServiceTypeCommand, ContractorServiceTypeUsageResponse, DeleteAuthServiceTypeCommand, GetContractorEmployeeServicesTypeUsageCommand, GetServiceTypesWithoutAuthForEmployeeCommand, GetServiceTypesWithoutAuthForEmployeeResponse } from "./command/employee-services-type-usage.command";
import { ImportContractorEmployeeCommand, IImportContractorEmployeeResponse } from "./command/importContractorEmployee.command";
import { ImportContractorAreaCommand, IImportContractorAreaResponse } from "./command/importContractorArea.command";
import { TranslateService } from "@ngx-translate/core";
import { GetPassengerByAreaCommand, IGetPassengerByAreaCommandParameters } from './command/getPassengerByArea.command';

@Injectable()
export class ContractorService {
  private titleMessage: string;
  constructor(
    private _connectionService: ConnectionServices,
    private _notificationsService: NotificationsService,
    private _identityService: IdentityService,
    // private _multiregionService: MultiRegionService,
    private _translateService: TranslateService
  ) {
    this.titleMessage = 'toast.contractor.company';
  }

  //   public changeSolicitudeToPending(
  //     id: number,
  //     token: string
  //   ): Observable<boolean> {
  //     let statusCommand = new ChangeContractorSolicitudeStatusCommand(id, token);
  //     return this._connectionService
  //       .Request(statusCommand)
  //       .map(data => {
  //         return true;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage('toast.authentication.confirmation', error);
  //         return Observable.throw(error);
  //       });
  //   }

  //   addContractor(contractor: ContractorUserRequestDto) {
  //     let id = this._identityService.userId;
  //     let updateCommand = new ContractorAddUserCommand();
  //     updateCommand.setParameters(<IContractorAddUserParameters>{
  //       contractorUserId: this._identityService.userId,
  //       firstName: contractor.firstName,
  //       lastName: contractor.lastName,
  //       email: contractor.email,
  //       genre: contractor.genre,
  //       phone: contractor.phone,
  //       authCarPool: contractor.authCarPool,
  //       costCenterId: contractor.costCenterId,
  //       role: contractor.role
  //     });
  //     return this._connectionService
  //       .Request(updateCommand)
  //       .map(data => {
  //         return true;
  //       })
  //       .catch(error => {
  //         if (
  //           error.error.errorCode !== undefined &&
  //           error.error.errorCode !== null &&
  //           error.error.errorCode !== 'undefined'
  //         ) {
  //           if (error.error.errorCode === ErrorsEnum.MAIL_UNIQUE) {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.contractor.user',
  //               'toast.users.error_code.mail_unique'
  //             );
  //           }
  //         } else {
  //           this._notificationsService.showHttpErrorMessage(
  //             'toast.contractor.user',
  //             error
  //           );
  //         }
  //         return Observable.throw(error);
  //       });
  //   }

  //   updateAccount(data: ContractorAccountUpdateRequestDTO): Observable<boolean> {
  //     let updateCommand = new ContractorAccountUpdateCommand();
  //     updateCommand.setParameters(<IContractorUpdateCommandParameters>{
  //       contractorUserId: this._identityService.userId,
  //       companyName: data.companyName,
  //       imageLogo: data.imageLogo,
  //       phoneNumber: data.phoneNumber,
  //       address: data.address
  //     });
  //     return this._connectionService
  //       .Request(updateCommand)
  //       .map(() => true)
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage('toast.configuration.preferences', error);
  //         return Observable.throw(error);
  //       });
  //   }

  //     updatePreferences(data: ContractorPreferences): Observable<boolean> {
  //     let updateCommand = new ContractorPreferencesUpdateCommand();
  //     updateCommand.setParameters(<IContractorUpdateCommandParameters>{
  //       contractorUserId: this._identityService.userId,
  //       imageLogo: data.imageLogo,
  //       companyName: data.companyName,
  //       companyFantasyName: data.companyFantasyName,
  //       tributeNumber: data.tributeNumber,
  //       tributeNumberImage: data.tributeNumberImage,
  //       checkingAccount: data.checkingAccount,
  //       expenseReportMode: data.expenseReportMode,
  //       phoneNumber: data.phoneNumber,
  //       email: data.email,
  //       password: data.password,
  //       billingPlace: data.billingPlace,
  //       locationPlace: data.locationPlace

  //     });
  //     return this._connectionService
  //       .Request(updateCommand)
  //       .map(() => true)
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage('toast.configuration.preferences', error);
  //         return Observable.throw(error);
  //       });
  //   }

  //   createCostCenter(costCenter: string): Observable<ICreateCostCenterResponse> {
  //     let createCommand = new CreateCostCenterCommand();
  //     createCommand.setParameters(<ICreateCostCenterCommandParameters>{
  //       title: costCenter
  //     });
  //     return this._connectionService
  //       .Request(createCommand)
  //       .map(data => {
  //         return data;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(error);
  //       });
  //   }

  createContractorArea(
    contractorArea: IContractorAreaRequestDTO
  ): Observable<ICreateContractorAreaResponse> {
    let createCommand = new CreateContractorAreaCommand();
    createCommand.setContractorId(
      contractorArea.contractorId ? (contractorArea.contractorId) : (+this._identityService.userId),
    );
    createCommand.setCommandBody(contractorArea);
    return this._connectionService
      .Request(createCommand)
      .pipe(
        map((response: ICreateContractorAreaResponse) => {
          this._notificationsService.showSuccessMessage(
            'toast.contractor.area',
            'toast.shared.message.successful_message_add'
          );
          return response;
        }),
        catchError(error => {
          if (error.status === 409) {
            this._notificationsService.showInternalErrorMessage(
              'toast.contractor.area',
              error.error.errorCode === 'CONTRACTOR_AREA_UNIQUE' ?
                'toast.contractor.error_code.area_already_exist' :
                'toast.contractor.error_code.cost_center_already_exist'
            );
          } else {
            this._notificationsService.showHttpErrorMessage(
              'toast.contractor.area',
              error
            );
          }
          return throwError(() => false);
        })
      );
  }

  updateContractorArea(
    contractorArea: IContractorAreaRequestDTO
  ): Observable<IUpdateContractorAreaResponse> {
    let updateCommand = new UpdateContractorAreaCommand();
    updateCommand.setIds(
      contractorArea.contractorId ? (contractorArea.contractorId) : (+this._identityService.userId),
      contractorArea.id
    );
    updateCommand.setCommandBody(contractorArea);
    return this._connectionService
      .Request(updateCommand)
      .pipe(
        map((response: IUpdateContractorAreaResponse) => {
          this._notificationsService.showSuccessMessage(
            'toast.contractor.area',
            'toast.shared.message.successful_message_edit'
          );
          return response;
        }),
        catchError(error => {
          if (error.status === 409) {
            this._notificationsService.showInternalErrorMessage(
              'toast.contractor.area',
              error.error.errorCode === 'CONTRACTOR_AREA_UNIQUE' ?
                'toast.contractor.error_code.area_already_exist' :
                'toast.contractor.error_code.cost_center_already_exist'
            );
          } else {
            this._notificationsService.showHttpErrorMessage(
              'toast.contractor.area',
              error
            );
          }
          return throwError(() => false);
        })
      );
  }

  //   public importContractorAreas(csv: File,
  //     contractor: string): Observable<IImportContractorAreaResponse> {
  //       let importCommand = new ImportContractorAreaCommand();
  //       let form = new FormData()
  //       form.append('csv', csv, csv.name)
  //       form.append('contractor', contractor)
  //       importCommand.setParameters(form);
  //       return this._connectionService
  //         .Request(importCommand)
  //         .map(data => {
  //           if (data.successLines > 0) {
  //             this._notificationsService.showSuccessMessage(
  //               'toast.contractor.area',
  //               this._translateService.instant('contractor.area.import.success_message')
  //                 .replace('{lines}', data.successLines)
  //             );
  //           }
  //           return data;
  //         })
  //         .catch(error => {
  //           this._notificationsService.showHttpErrorMessage('toast.contractor.area', error);
  //           return Observable.throw(false);
  //         });
  //   }

  //   getCostCenterById(
  //     costCenterId: string,
  //     contractorUserId: string
  //   ): Observable<IGetCostCenterByIdResponse> {
  //     let createCommand = new GetCostCenterByIdCommand();
  //     createCommand.setParameters(<IGetCostCenterByIdCommandParameters>{
  //       contractorUserId: contractorUserId,
  //       costCenterId: costCenterId
  //     });
  //     return this._connectionService
  //       .Request(createCommand)
  //       .map(data => {
  //         return data;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(error);
  //       });
  //   }

  //   public putCostCenter(
  //     costCenterId: string,
  //     contractorUserId: string,
  //     title: string
  //   ): Observable<IPutCostCenterResponse> {
  //     let createCommand = new PutCostCenterCommand();
  //     createCommand.setParameters(<IPutCostCenterCommandParameters>{
  //       contractorUserId: contractorUserId,
  //       costCenterId: costCenterId,
  //       title: title
  //     });
  //     return this._connectionService
  //       .Request(createCommand)
  //       .map(data => {
  //         return data;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(error);
  //       });
  //   }

  createContractorEmployee(
    contractorEmployee: IContractorEmployeeRequestDto & {contractorId:number}
  ): Observable<ICreateContractorEmployeeResponse> {
    let createCommand = new CreateContractorEmployeeCommand();
    createCommand.setContractorId(contractorEmployee.contractorId);
    createCommand.setCommandBody(contractorEmployee);
    return this._connectionService
      .Request(createCommand)
      .pipe(map((response: ICreateContractorEmployeeResponse) => {
        this._notificationsService.showSuccessMessage(
          'toast.contractor.employee',
          'toast.contractor.message.contractor_employee_created'
        );
        return response;
      }),
      catchError(error => {
        if (error.status === 409) {
          this._notificationsService.showInternalErrorMessage(
            'toast.contractor.employee',
            'toast.users.error_code.mail_unique'
          );
        } else if (error.error.errorCode === 'MAIL_UNIQUE') {
          this._notificationsService.showInternalErrorMessage(
            'toast.contractor.employee',
            'toast.users.error_code.mail_unique'
          );
          return throwError(() => error);
        } else {
          this._notificationsService.showHttpErrorMessage('toast.contractor.employee', error);
        }
        return throwError(() => false);
      }));
  }

  getContractorEmployee(id: number): Observable<IContractorEmployeeResponseDto> {
    let createCommand = new GetContractorEmployeeCommand();
    createCommand.setParameters({ id });
    return this._connectionService
      .Request(createCommand)
      .pipe(
        map(data => {
          return data as any as IContractorEmployeeResponseDto;
        }),
        catchError(error => {
        this._notificationsService.showHttpErrorMessage(
          this.titleMessage,
          error
        );
        return throwError(() => false);
        })
      );
  }

  updateContractorEmployee(
    contractorEmployee: IContractorEmployeeRequestDto & {contractorId:number}
  ): Observable<IUpdateContractorEmployeeResponse> {
    let updateCommand = new UpdateContractorEmployeeCommand();
    updateCommand.setIds(contractorEmployee.contractorId, contractorEmployee.id);
    updateCommand.setCommandBody(contractorEmployee);
    return this._connectionService
      .Request(updateCommand)
      .pipe(map((response: IUpdateContractorEmployeeResponse) => {
        this._notificationsService.showSuccessMessage(
          'toast.contractor.employee',
          'toast.contractor.message.contractor_employee_updated'
        );
        return response;
      }),
      catchError(error => {
        if (error.status === 409) {
          this._notificationsService.showInternalErrorMessage(
            'toast.contractor.employee',
            'toast.users.error_code.mail_unique'
          );
        } else {
          this._notificationsService.showHttpErrorMessage('toast.contractor.employee', error);
        }
        return throwError(() => false);
      }));
  }

  public importContractorEmployees(csv: File,
    contractor: string): Observable<IImportContractorEmployeeResponse> {
      let importCommand = new ImportContractorEmployeeCommand();
      let form = new FormData()
      form.append('csv', csv, csv.name)
      form.append('contractor', contractor)
      importCommand.setParameters(form);
      return this._connectionService
        .Request(importCommand)
        .pipe(map(data => {
          if (data.successLines > 0) {
            this._notificationsService.showSuccessMessage(
              'toast.contractor.employee',
              this._translateService.instant('contractor.employee.import.success_message')
                .replace('{lines}', String(data.successLines))
            );
          }
          return data;
        }),
        catchError(error => {
          this._notificationsService.showHttpErrorMessage('toast.contractor.employee', error);
          return throwError(() => false);
        }));
  }

  public importContractorAreas(csv: File,
    contractor: string): Observable<IImportContractorAreaResponse> {
      let importCommand = new ImportContractorAreaCommand();
      let form = new FormData();
      form.append('csv', csv, csv.name);
      form.append('contractor', contractor);
      importCommand.setParameters(form);
      return this._connectionService
        .Request(importCommand)
        .pipe(
          map(data => {
            if (data.successLines > 0) {
              this._notificationsService.showSuccessMessage(
                'toast.contractor.area',
                this._translateService.instant('contractor.area.import.success_message')
                  .replace('{lines}', String(data.successLines))
              );
            }
            return data;
          }),
          catchError(error => {
            this._notificationsService.showHttpErrorMessage('toast.contractor.area', error);
            return throwError(() => false);
          })
        );
  }

  //   public getAreasByContractorId(userId = this._identityService.userId): Observable<IContractorAreaResponseDTO[]> {
  //     let createCommand = new GetAreasByContractorIdCommand();
  //     let contractorId = +userId;
  //     createCommand.setParameters(<IGetAreasByContractorIdCommandParameters>{
  //       contractorUserId: contractorId.toString(),
  //       exludeAreaId: null
  //     });
  //     return this._connectionService
  //       .Request(createCommand)
  //       .map(data => {
  //         return data;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(error);
  //       });
  //   }

  public getAreasByExternalContractorId(contractorId): Observable<IContractorAreaResponseDTO[]> {
    let createCommand = new GetAreasByContractorIdCommand();
    createCommand.setParameters(<IGetAreasByContractorIdCommandParameters>{
      contractorUserId: contractorId.toString(),
      exludeAreaId: null
    });
    return this._connectionService
      .Request(createCommand)
      .pipe(
        map(data => {
          return data as any as IContractorAreaResponseDTO[];
        }),
        catchError(error => {
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          return throwError(() => error);
        })
      );
  }

  public getAreasByContractorId(userId = this._identityService.userId): Observable<IContractorAreaResponseDTO[]> {
    let createCommand = new GetAreasByContractorIdCommand();
    let contractorId = +userId;
    createCommand.setParameters(<IGetAreasByContractorIdCommandParameters>{
      contractorUserId: contractorId.toString(),
      exludeAreaId: null
    });
    return this._connectionService
      .Request(createCommand)
      .pipe(
        map(data => {
          return data as any as IContractorAreaResponseDTO[];
        }),
        catchError(error => {
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          return throwError(() => error);
        })
      );
  }

  //   public getAreasByContractorIdAndExlude(exludeAreaId: number): Observable<IContractorAreaResponseDTO[]> {
  //     let createCommand = new GetAreasByContractorIdCommand();
  //     let contractorId = +this._identityService.userId;
  //     createCommand.setParameters(<IGetAreasByContractorIdCommandParameters>{
  //       contractorUserId: contractorId.toString(),
  //       exludeAreaId: exludeAreaId
  //     });
  //     return this._connectionService
  //       .Request(createCommand)
  //       .map(data => {
  //         return data;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(error);
  //       });
  //   }

  deleteContractorEmployee(
    contractorEmployeeId: number
  ): Observable<IUpdateContractorEmployeeResponse> {
    let deleteCommand = new DeleteContractorEmployeeCommand();
    deleteCommand.setId(contractorEmployeeId);
    return this._connectionService
      .Request(deleteCommand)
      .pipe(
        map((response: IUpdateContractorEmployeeResponse) => {
          this._notificationsService.showSuccessMessage(
            'toast.contractor.employee',
            'toast.contractor.message.contractor_employee_deleted'
          );
          return response;
        }),
        catchError(error => {
          this._notificationsService.showHttpErrorMessage('toast.contractor.employee', error);
          return throwError(() => false);
        })
      );
  }

  deleteContractorArea(
    contractorId: number,
    contractorAreaId: number
  ): Observable<IUpdateContractorAreaResponse> {
    let deleteCommand = new DeleteContractorAreaCommand();
    deleteCommand.setId(contractorId, contractorAreaId);
    return this._connectionService
      .Request(deleteCommand)
      .pipe(
        map((response: IUpdateContractorAreaResponse) => {
          this._notificationsService.showSuccessMessage(
            'toast.contractor.area',
            'toast.contractor.message.contractor_area_deleted'
          );
          return response;
        }),
        catchError(error => {
          if (error.status != 400) {
            this._notificationsService.showInternalErrorMessage(
              'toast.contractor.area',
              'toast.contractor.error_code.contractor_area_deleted_error'
            );
          }
          return throwError(() => error);
        })
      );
  }

  saveContractorAssignArea(
    contractorArea: IContractorAreaAssignRequestDTO
  ): Observable<IAssignContractorAreaResponse> {
    let areaAssignCommand = new AssignContractorAreaCommand();
    areaAssignCommand.setId(
      contractorArea.contractorId ? (+contractorArea.contractorId) : (+this._identityService.userId),
      contractorArea.id,
      contractorArea.idAssignArea
    );
    return this._connectionService
      .Request(areaAssignCommand)
      .pipe(
        map((response: IAssignContractorAreaResponse) => {
          this._notificationsService.showSuccessMessage(
            'toast.contractor.area',
            'toast.contractor.message.contractor_area_deleted'
          );
          return response;
        }),
        catchError(error => {
          if (error.status == 403) {
            this._notificationsService.showInternalErrorMessage(
              'toast.contractor.area',
              'toast.contractor.error_code.contractor_area_deleted_error');
          } else {
            if (error.status != 400) {
              this._notificationsService.showHttpErrorMessage('toast.contractor.area', error);
            }
          }

          return throwError(() => error);
        })
      );
  }

  //   getContractorsByCarrier(term: string)
  //     : Observable<ContractorComboDTO[]> {
  //   const contractorCommand = new GetContractorsByCarrierCommand();
  //   contractorCommand.setParameters(<IGetContractorsByCarrierCommandParameters>{
  //   terms: term,
  //   carrierId: this._identityService.userId
  // });
  // return this._connectionService
  //   .Request(contractorCommand)
  //   .map(data => {
  //     const response = data as ContractorComboDTO[];
  //     return response;
  //   })
  //   .catch(error => {
  //     this._notificationsService.showHttpErrorMessage(
  //       this.titleMessage,
  //       error
  //     );
  //     return Observable.throw(false);
  //   });
  //   }

  //   getContractorsByMagiisNumber(magiisNumber: string): Observable<ContractorByMagiisResponseDTO> {
  //     const command = new GetContractorByMagiisNumberCommand();
  //     const params: IGetContractorByMagiisNumberCommandParameters = {
  //       magiisNumber
  //     };
  //     command.setParameters(params);
  //     return this._connectionService
  //       .Request(command)
  //       .map((response: ContractorByMagiisResponseDTO) => {
  //         return response;
  //       })
  //       .catch(error => {
  //         if (error.error.errorCode === 'CODE_NOT_FOUND') {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.contractor.company_info',
  //             'toast.contractor.error_code.invalid_company_number'
  //           );
  //         } else {
  //           this._notificationsService.showHttpErrorMessage(
  //             'toast.contractor.company_info',
  //             error
  //           );
  //         }
  //         return Observable.throw(error);
  //       });
  //   }

  getContractorByTributeNumber(tributeNumber: string): Observable<ContractorResponseDto> {
    const command = new GetContractorByTributeNumberCommand();
    const params: IGetContractorByTributeNumberCommandParameters = {
      tributeNumber
    };
    command.setParameters(params);
    return this._connectionService
      .Request(command)
      .pipe(
        map((response: IGetContractorByTributeNumberResponse) => {
          return response;
        }),
        catchError(error => {
          return throwError(() => error);
        })
      );
  }

  //   public getEmployeesByContractor(term?: string): Observable<IContractorEmployeeResponseDto[]> {
  //     let createCommand = new GetContractorEmployeesCommand();
  //     let contractorId = +this._identityService.userId;
  //     createCommand.setParameters(<IGetContractorEmployeesCommandParameters>{
  //       contractorId: contractorId.toString(),
  //       name: term
  //     });
  //     return this._connectionService
  //       .Request(createCommand)
  //       .map(data => {
  //         return data;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(error);
  //       });
  //   }

  public getEmployeesByContractorPassengerId(passengerId: number, term?: string): Observable<IContractorEmployeeResponseDto[]> {
    let createCommand = new GetContractorEmployeesByPassengerIdCommand();
    createCommand.setParameters(<IGetContractorEmployeesByPassengerCommandParameters>{
      passengerId: passengerId.toString(),
      name: term
    });

    return this._connectionService
      .Request(createCommand)
      .pipe(
        map(response => {
          return response as any;
        }),
        catchError((error) => {
          //     this._notificationsService.showHttpErrorMessage(
          //       this.titleMessage,
          //       error
          //     );
          return throwError(() => false);
        })
      );
    // return this._connectionService
    //   .Request(createCommand)
    //   .map(data => {
    //     return data;
    //   })
    //   .catch(error => {
    //     this._notificationsService.showHttpErrorMessage(
    //       this.titleMessage,
    //       error
    //     );
    //     return Observable.throw(error);
    //   });
  }


  public reSendContractorEmployeesNotification(
    contractorEmployee: IContractorEmployeesResendInviteCommandParameters
  ): Observable<IContractorEmployeesResendInviteResponse> {
    let command = new ContractorEmployeesResendInviteCommand();
    command.setParameters(contractorEmployee);
    return this._connectionService
      .Request(command)
      .pipe(
        map((response: IContractorEmployeesResendInviteResponse) => {
          return response;
        }),
        catchError(error => {
          return throwError(() => error);
        })
      );
  }
  //     return this._connectionService
  //       .Request(command)
  //       .map((response: IContractorEmployeesResendInviteResponse) => {
  //         this._notificationsService.showSuccessMessage(
  //           'toast.contractor.employee',
  //           'toast.contractor.message.resend_email_success',
  //         );
  //         return response;
  //       })
  //       .catch(error => {
  //         if(error.status == 403){
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.contractor.employee',
  //             'toast.contractor.error_code.resend_email_error');
  //         }else{
  //           if(error.status != 400){
  //             this._notificationsService.showHttpErrorMessage('toast.contractor.employee', error);
  //           }
  //         }

  //         return Observable.throw(error);
  //       });
  //   }
  //   public getContractorRelatedCarriers(searchTerm: string, size: number): Observable<CarrierByContractorDTO[]> {
  //     let createCommand = new GetContractorRelatedCarriersCommand();
  //     let contractorId = +this._identityService.userId;
  //     createCommand.setParameters(<IGetContractorRelatedCarriersCommandParameters>{
  //       contractorId: contractorId.toString(),
  //       find: searchTerm,
  //       page: 1,
  //       sort: 'ASC',
  //       column: 'id',
  //       size: size,
  //       status: 'ACCECAR-ACCECON-LOCAL'
  //     });
  //     return this._connectionService
  //       .Request(createCommand)
  //       .map(data => {
  //         return data.content;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(error);
  //       });
  //   }

  //   getContractorCheckingAccount(term: number)
  //   : Observable<ContractorComboDTO[]> {
  //     const contractorCommand = new GetContractorCheckingAccountCommand();
  //     contractorCommand.setParameters(<IGetContractorCheckingAccountCommandParameters>{
  //       contractorUserId: term,
  //       carrierUserId: +this._identityService.userId
  //     });
  //     return this._connectionService
  //       .Request(contractorCommand)
  //       .map(data => {
  //         const response = data as ContractorComboDTO[];
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           this.titleMessage,
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   getContractorDashboard()
  //   : Observable<ContractorTravelsDashboardDTO> {
  //     const contractorCommand = new GetContractorDashboardCommand();
  //     contractorCommand.setParameters(<IGetContractorDashboardCommandParameters>{
  //       contractorUserId: +this._identityService.userId
  //     });
  //     return this._connectionService
  //     .Request(contractorCommand)
  //     .map(data => {
  //       const response = data as ContractorTravelsDashboardDTO;
  //       return response;
  //     })
  //     .catch(error => {
  //       this._notificationsService.showHttpErrorMessage(
  //         this.titleMessage,
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  //   }

  //   updateLocalContractor(
  //     localContractorDTO: LocalContractorDTO
  //   ): Observable<any> {
  //     let updateCommand = new UpdateLocalContractorCommand();
  //     updateCommand.setIds(localContractorDTO.contractorId, localContractorDTO.fareId);
  //     updateCommand.setCommandBody({
  //       carrierId: +this._identityService.userId,
  //       companyName: localContractorDTO.contractorName,
  //       tributeNumber: localContractorDTO.tributeNumber
  //     });
  //     return this._connectionService
  //       .Request(updateCommand)
  //       .map((response: IContractorEmployeeResponseDto) => {
  //         this._notificationsService.showSuccessMessage(
  //           'toast.contractor.companies',
  //           'toast.contractor.message.company_updated'
  //         );
  //         return response;
  //       })
  //       .catch(error => {
  //         if (error.error.errorCode === ErrorsEnum.CONTRACTOR_FANTASY_NAME_UNIQUE) {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.contractor.companies',
  //             'toast.contractor.error_code.name_unique');
  //         } else if (error.error.errorCode === ErrorsEnum.CONTRACTOR_TRIBUTE_NUMBER_UNIQUE) {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.contractor.companies',
  //             'toast.users.error_code.cuil_unique');
  //         } else {
  //           this._notificationsService.showHttpErrorMessage(
  //             'toast.contractor.companies',
  //             error);
  //         }
  //         return Observable.throw(false);
  //       });
  //   }

  getContractorAccountById(id: number)
    : Observable<ContractorResponseDto> {
    const contractorCommand = new GetContractorByIdCommand();
    contractorCommand.setParameters({
      contractorId: id.toString(),
      carrierId: this._identityService.userId
    });
    return this._connectionService
      .Request(contractorCommand)
      .pipe(
        map(data => {
          const response = data as ContractorResponseDto;
          return response;
        }),
        catchError(error => {
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          return throwError(() => false);
        })
      );
  }

  getContractorById(id: number): Observable<ContractorResponseDto> {
    const contractorCommand = new GetContractorByEntityIdCommand();
    contractorCommand.setParameters({
      id: id.toString()
    });
    return this._connectionService
      .Request(contractorCommand)
      .pipe(
        map(data => {
          const response = data as ContractorResponseDto;
          return response;
        }),
        catchError(error => {
          this._notificationsService.showHttpErrorMessage(
            this.titleMessage,
            error
          );
          return throwError(() => false);
        })
      );
  }

  //     getContractorPreferences(id: number)
  //   : Observable<ContractorResponseDto> {
  //     const contractorCommand = new GetContractorPreferences();
  //     contractorCommand.setParameters({
  //       contractorAccountId: id.toString()
  //     });
  //     return this._connectionService
  //     .Request(contractorCommand)
  //     .map(data => {
  //       const response = data as ContractorResponseDto;
  //       return response;
  //     })
  //     .catch(error => {
  //       this._notificationsService.showHttpErrorMessage(
  //         this.titleMessage,
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  //   }

  //   getContractorUser(userId: number): Observable<ContractorUserResponseDto> {
  //     let getContractorUserCommand = new GetContractorUserCommand();
  //     getContractorUserCommand.setParameters({
  //       contractorId: this._identityService.userId,
  //       contractorUserId: userId.toString()
  //     });
  //     return this._connectionService
  //     .Request(getContractorUserCommand)
  //     .map(data => {
  //       const response = data as ContractorUserRequestDto;
  //       return response;
  //     })
  //     .catch(error => {
  //       this._notificationsService.showHttpErrorMessage(
  //         this.titleMessage,
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  //   }

  //   deleteUserProfile(userId: number): Observable<void> {
  //     let newUserProfileCommand = new DeleteUserProfileCommand();
  //     newUserProfileCommand.setParameters({
  //       userId: userId
  //     });
  //     return this._connectionService
  //       .Request(newUserProfileCommand)
  //       .map(signUpResponse => {
  //         this._notificationsService.showSuccessMessage(
  //           'toast.carrier.profiles',
  //           'toast.users.message.user_deleted'
  //         );
  //         return new Observable<true>();
  //       })
  //       .catch(error => {
  //         if (error.status === 409) {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.carrier.profiles',
  //             error.error.description
  //           );
  //           return of(true);
  //         }
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.carrier.profiles',
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   updateContractorUser(contractor: ContractorUserRequestDto) {
  //     let id = this._identityService.userId;
  //     let updateCommand = new ContractorUserUpdateCommand();
  //     updateCommand.setParameters(<IContractorUserUpdateParameters>{
  //       contractorId: this._identityService.userId.toString(),
  //       contractorUserId: contractor.userId.toString(),
  //       firstName: contractor.firstName,
  //       lastName: contractor.lastName,
  //       email: contractor.email,
  //       genre: contractor.genre,
  //       phone: contractor.phone,
  //       authCarPool: contractor.authCarPool,
  //       costCenterId: contractor.costCenterId,
  //       role: contractor.role
  //     });
  //     return this._connectionService
  //       .Request(updateCommand)
  //       .map(data => {
  //         return true;
  //       })
  //       .catch(error => {
  //         if (
  //           error.error.errorCode !== undefined &&
  //           error.error.errorCode !== null &&
  //           error.error.errorCode !== 'undefined'
  //         ) {
  //           if (error.error.errorCode === ErrorsEnum.MAIL_UNIQUE) {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.contractor.user',
  //               'toast.users.error_code.mail_unique'
  //             );
  //           }
  //         } else {
  //           this._notificationsService.showHttpErrorMessage(
  //             'toast.contractor.user',
  //             error
  //           );
  //         }
  //         return Observable.throw(error);
  //       });
  //   }

  getEmailTemplates(idContractor: number, language?: string) {
    const command = new GetEmailTemplatesCommand();
    command.setParameters({
      idContractor: idContractor,
      language: language
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          this._notificationsService.showHttpErrorMessage(
            'toast.shared.error_code.0',
            error
          );
          return throwError(() => false);
        })
      );
  }

  //   restoreEmailTemplate(idTemplate: number) {
  //     const command = new DeleteEmailTemplateCommand();
  //     command.setParameters({
  //       idTemplate: idTemplate
  //     });
  //     return this._connectionService
  //       .Request(command)
  //       .map((response) => {
  //         return response;
  //       })
  //       .catch((error) => {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.shared.error_code.0',
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  putEmailTemplate(contractorId: number, email: any) {
    const command = new PutEmailTemplateCommand();
    command.setParameters({
      contractorId: contractorId,
      id: email.id,
      userId: email.userId,
      html: email.html,
      logoPlacement: email.logoPlacement,
      languageCode: email.languageCode,
      userType: email.userType
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          this._notificationsService.showHttpErrorMessage(
            'toast.shared.error_code.0',
            error
          );
          return throwError(() => false);
        })
      );
  }

  employeeServicesUsage(employeeId: string): Observable<Array<ContractorServiceTypeUsageResponse>> {
    const command = new GetContractorEmployeeServicesTypeUsageCommand();
    command.setParameters({
      contractorEmployeeId: employeeId
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map((response: Array<ContractorServiceTypeUsageResponse>) => {
          return response;
        }),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  addOrSubstractLimitServiceType(action: string, serviceTypeId: number, contractorEmployeeId: string) {
    const command = new AddSubstractLimitServiceTypeCommand();
    command.setParameters({
      action: action,
      serviceTypeId: serviceTypeId,
      contractorEmployeeId: contractorEmployeeId,
      userId: +this._identityService.subUserId
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  deleteAuthorizationServiceType(serviceTypeId: number, contractorEmployeeId: string) {
    const command = new DeleteAuthServiceTypeCommand();
    command.setParameters({
      contractorEmployeeId: contractorEmployeeId,
      serviceTypeId: serviceTypeId
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  getServiceTypesWithoutAuthForEmployee(contractorEmployeeId: string): Observable<Array<GetServiceTypesWithoutAuthForEmployeeResponse>> {
    const command = new GetServiceTypesWithoutAuthForEmployeeCommand();
    command.setParameters({
      carrierId: +this._identityService.userId,
      contractorEmployeeId: contractorEmployeeId
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map((response: Array<GetServiceTypesWithoutAuthForEmployeeResponse>) => {
          return response;
        }),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  addAuthServiceType(serviceTypeId: string, contractorEmployeeId: string) {
    const command = new AddAuthServiceTypeCommand();
    command.setParameters({
      contractorEmployeeId: contractorEmployeeId,
      serviceTypeId: serviceTypeId,
      userId: +this._identityService.subUserId
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  /**
   * MX-5600: Get total company/contractor clients count for dashboard Card 5.
   * Endpoint: GET carrier/{carrierId}/contractors/totals (singular /carrier/)
   */
  public getTotalContractors(): Observable<{ countLocal: number; countACCECAR: number }> {
    const command = new GetCountContractorsCommand();
    command.setParameters(<IGetCountContractorsParameters>{
      carrierUserId: this._identityService.userId
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(data => data as { countLocal: number; countACCECAR: number }),
        catchError(error => {
          console.error('Error fetching total contractors:', error);
          return throwError(() => error);
        })
      );
  }

  public getPassengerByArea(areaId: string): Observable<{ content: Array<{ id: number; name: string; lastName: string }> }> {
    const command = new GetPassengerByAreaCommand();
    command.setParameters(<IGetPassengerByAreaCommandParameters>{ areaId });
    return this._connectionService
      .Request(command)
      .pipe(
        map(data => data as any),
        catchError(error => {
          this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
          return throwError(() => error);
        })
      );
  }
}
